import { observable, computed } from "mobx-angular";
import { Injectable } from "@angular/core";
import { DbService } from "src/providers/core/database.service";
import { ITag } from "src/models/wpModels";

@Injectable({
  providedIn: "root",
})
export class TagsStore {
  @observable tags: ITag[];
  @computed get topTags() {
    return this._filterTopTags(this.tags);
  }
  @computed get aTags() {
    return this._sortAlphabeticatlly(this.tags);
  }

  constructor(public db: DbService) {
    this.init();
  }
  public async init() {
    this.db.getCollection("tags", "id").subscribe((tags) => {
      this.tags = tags;
    });
  }

  private _filterTopTags(tags?: ITag[]) {
    if (tags) {
      tags = tags
        .slice()
        .sort((a, b) => b.count - a.count)
        .slice(0, 20);
      return tags;
    } else {
      return [];
    }
  }
  private _sortAlphabeticatlly(tags?: ITag[]) {
    if (tags) {
      tags = tags.slice().sort((a, b) => (b.name > a.name ? -1 : 0));
      return tags;
    } else {
      return [];
    }
  }
}
